/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645463796613,
	"notificationDetails": {"updateType":"SETUP_FILTERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "WORK_ORDER_SAFETY_NET",
	"statusDetails": {"firstBidAsk":1.1,"currentBidAsk":1.4,"safetyNetPct":0.25,"bidAskType":"bid"},
	"date": "2022-02-21T12:16:37.419-0500",
	"timestamp": "1645463797419"
}

 * @param {*} statusDetails 
 * @returns an object with four fields.
 * 1) firstBidAsk: first bid/ask depending on trade direction from when working the order began
 * 2) currentBidAsk: the bid/ask that triggered the safety net
 * 3) safetyNetPct: what pct setting the user wanted to trigger the safety net. so if the first ask was 1.8, and this was set to .1 (10%), filter the trade if ask hits 2.
 * 4) bidAskType: for the firstBidAsk and the currentBidAsk, are those values the bid or the ask? (values are either "bid" or "ask")
 */
export function workOrderSafetyNetParser(statusDetails) {
  const parsedObj = {
    firstBidAsk: null,
    currentBidAsk: null,
    safetyNetPct: null,
    bidAskType: null,
  };
  if (statusDetails) {
    parsedObj.firstBidAsk = statusDetails.firstBidAsk ?? null;
    parsedObj.currentBidAsk = statusDetails.currentBidAsk ?? null;
    parsedObj.safetyNetPct = statusDetails.safetyNetPct ?? null;
    parsedObj.bidAskType = statusDetails.bidAskType ?? null;
  }

  return parsedObj;
}
